import { STEP_KEYS, type DeliverySelection } from '~/components/common/delivery-run-panel';

/**
 * Which content actually represents the "description" field once delivered.
 * Search Descriptors and Phrase Descriptions (see `docs/product-description-view-toggle.md`,
 * PR #750) are alternate forms of the same field, not a separate one — the
 * operator can select more than one of the three in Step 1's attribute
 * picker, but only one variant ever ships. Phrase Descriptions supersedes
 * Search Descriptors supersedes the plain description.
 */
export type DescriptionDeliveryView = 'phrase-descriptions' | 'search-descriptors' | 'description';

/** Resolves the winning view from the operator's Step 1 selection, or `null`
 *  when none of the three description-family keys were selected (the
 *  description field isn't being delivered at all). */
export function resolveDescriptionDeliveryView(
  selection: DeliverySelection,
): DescriptionDeliveryView | null {
  if (selection.decision !== 'APPROVED') return null;
  const selected = new Set(selection.attributeKeys);
  if (selected.has(STEP_KEYS.phraseDescriptions)) return 'phrase-descriptions';
  if (selected.has(STEP_KEYS.searchDescriptors)) return 'search-descriptors';
  if (selected.has('description')) return 'description';
  return null;
}
